import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-82">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[60] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={title} data-id="element-83">
          <div className="absolute inset-0 bg-brand-text/50 backdrop-blur-sm" onClick={onClose} data-id="element-84" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative bg-white rounded-3xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden" data-id="element-85">
            <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-brand-brown/10 flex-shrink-0" data-id="element-86">
              <h2 className="text-xl md:text-2xl font-serif font-bold text-brand-brown" data-id="element-87">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="w-9 h-9 flex items-center justify-center rounded-full text-brand-textLight hover:bg-brand-cream transition-colors focus:outline-none focus:ring-2 focus:ring-brand-brown/30" data-id="element-88">
                <X className="w-5 h-5" data-id="element-89" />
              </button>
            </div>
            <div className="px-6 md:px-8 py-6 overflow-y-auto text-brand-textLight leading-relaxed space-y-4 text-sm md:text-base" data-id="element-90">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}